// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__yuhVt","filesListContainer":"PosDisputesFiles_filesListContainer__2yrcj","filesButton":"PosDisputesFiles_filesButton__2aNbY"};